import { render, staticRenderFns } from "./ProductionProcess.vue?vue&type=template&id=64b8fb10&scoped=true"
import script from "./ProductionProcess.vue?vue&type=script&lang=js"
export * from "./ProductionProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8fb10",
  null
  
)

export default component.exports